import { ScreenWidthMaxMedium, ScreenWidthMaxSmall, ScreenWidthMinMedium, getScreenSelector } from '@uifabric/styling';
export var MinimumScreenSelector = getScreenSelector(0, ScreenWidthMaxSmall);
export var MediumScreenSelector = getScreenSelector(ScreenWidthMinMedium, ScreenWidthMaxMedium);
//# sourceMappingURL=styleConstants.js.map